import React from 'react' 
import { Route, Routes } from 'react-router-dom'; 
import Password from '../profile/Password';

const PasswordRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/change" element={<Password />} />
            </Routes>
        </>
    )
}

export default PasswordRoutes;